import Immutable from 'immutable';
import { useMenu } from 'react-instantsearch';

import { facetAttributes } from '../components/SearchMaatjesProjects/config';

import { DEFAULT_LANGUAGE, SITE_NAME, REQUEST_TYPE_MAATJE_WORDEN } from '../config/constants';

/**
 * @param path
 * @param fallback
 */
export function getLanguageByPath(path, fallback = DEFAULT_LANGUAGE) {
  return /^\/[a-z]{2}(\/.*)?$/g.test(path)
    ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1')
    : fallback;
}

/**
 * @param title
 */
export function getDocumentTitle(title) {
  if (!title) {
    return SITE_NAME;
  }

  return `${title} | ${SITE_NAME}`;
}

/**
 * @param youtubeUrl
 */
export function getYoutubeIdFromUrl(youtubeUrl) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = youtubeUrl.match(regExp);

  return (match && match[2].length === 11)
    ? match[2]
    : null;
}

/**
 * @param amount
 */
export function formatMoney(amount) {
  const currencyFormatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  return currencyFormatter.format(amount).replace(',00', ',-');
}

/**
 * @param amount
 */
export function formatMoneyFromString(amount) {
  return formatMoney(parseFloat(amount));
}

/**
 * @param js
 */
export function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null ? js
    : Array.isArray(js)
      ? Immutable.Seq(js).map(fromJSOrdered).toList()
      : Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
}

// according to our containers
export const calculateDistanceToScreenBorder = (width) => {
  let distance = 20;
  if (width < 720) {
    distance = (width - 540) / 2;
  } else if (width < 960) {
    distance = (width - 720) / 2;
  } else if (width < 1200) {
    distance = (width - 960) / 2;
  } else if (width > 1200) {
    distance = (width - 1200) / 2;
  }
  return distance;
};

export function epochToDateString(date, lang = 'nl') {
  const asJsDate = new Date(0);
  asJsDate.setUTCSeconds(date);

  return new Intl.DateTimeFormat(lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(asJsDate);
}

export function getActiveRequestType() {
  const requestTypeFacet = facetAttributes.find((attr) => attr.field === 'field_request_type');
  const { items } = useMenu(requestTypeFacet);

  const refinedRequestType = items.find((item) => item.isRefined);
  return refinedRequestType?.value || REQUEST_TYPE_MAATJE_WORDEN;
}
